import {
    createI18n,
    LanguageCode,
} from '@gagovictor/shared-frontend-core/dist/i18n';

import { enUS, MessageKey } from './en-US';
import { ptBR } from './pt-BR';

export type { MessageKey } from './en-US';

/** The languages the app is translated into. The first is the fallback. */
export const LANGUAGES = [
    'en-US',
    'pt-BR',
] as const satisfies readonly LanguageCode[];
export type Language = (typeof LANGUAGES)[number];

export const { I18nProvider, useI18n, useT, translateIn, initialLanguage } =
    createI18n<Language, MessageKey>({
        languages: LANGUAGES,
        fallback: 'en-US',
        storageKey: 'tomato-pop:language',
        catalogs: { 'en-US': enUS, 'pt-BR': ptBR },
    });
